import { render, staticRenderFns } from "./burger.vue?vue&type=template&id=08e78e2a&scoped=true&"
import script from "./burger.vue?vue&type=script&lang=js&"
export * from "./burger.vue?vue&type=script&lang=js&"
import style0 from "./burger.vue?vue&type=style&index=0&id=08e78e2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e78e2a",
  null
  
)

export default component.exports